import styled from 'styled-components';

export const StyledControlBarButton = styled.button.attrs({
  type: 'button',
})`
  appearance: none;
  align-self: flex-start;
  background-color: transparent;
  border: 0;
  color: #0f4c81;
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  font-size: 1rem;
  margin: 0;
  padding: 0;

  &:hover {
    color: #fc7a1e;
  }

  > span {
    display: inline-flex;
  }
`;
